"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _normalizeStrings = _interopRequireDefault(require("normalize-strings"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var sanitizeString = function sanitizeString(string) {
  var normalisedStr = (0, _normalizeStrings["default"])(string).toLowerCase();
  return normalisedStr.replace(/[\u0300-\u036f]/g, '').replace(/([0-9]+)["”]/g, '$1-inch').replace(/['?:]/g, '').replace(/\s?[^A-Za-z0-9]\s/g, ' ').replace(/[!-/\[-`=]/g, '-').replace(/ /g, '-').replace(/-{2,}/g, '-').replace(/-$/g, '');
};
var getProductUrl = function getProductUrl(title, id, selectedSwatch, adId) {
  var encodedTitle = sanitizeString(title);
  var fragmentId = adId ? "#citrusAdId=".concat(adId) : '';
  if (selectedSwatch && Object.keys(selectedSwatch).length) {
    var color = selectedSwatch.color;
    return "/".concat(encodedTitle).concat(color ? "/".concat(sanitizeString(color)) : '', "/p").concat(id).concat(fragmentId);
  }
  return "/".concat(encodedTitle, "/p").concat(id).concat(fragmentId);
};
var _default = exports["default"] = getProductUrl;